import React, { useId } from 'react';
import { IconChevronDown } from '@tabler/icons-react';
import { COUNTRY_CODES } from '../../utils/constants';
import { formatLocalPhone } from '../../utils/format';

/** Mobile number with a country-code dropdown (all phone numbers carry a country code). */
export default function PhoneField({
  label = 'Mobile number', countryCode, onCountryCodeChange, value, onChange, error, hint, className = '', ...rest
}) {
  const id = useId();
  return (
    <div className={`field ${className}`}>
      {label && (
        <div className="field__head">
          <label className="field__label" htmlFor={id}>{label}</label>
        </div>
      )}
      <div className={`input ${error ? 'input--error' : ''}`}>
        <span className="phone-input__code">
          {countryCode}
          <IconChevronDown size={14} stroke={2.4} />
          <select
            className="phone-input__select"
            value={countryCode}
            onChange={(e) => onCountryCodeChange(e.target.value)}
            aria-label="Country code"
          >
            {COUNTRY_CODES.map((c) => (
              <option key={c.iso} value={c.code}>{`${c.name} (${c.code})`}</option>
            ))}
          </select>
        </span>
        <input
          id={id}
          className="input__control"
          type="tel"
          inputMode="numeric"
          autoComplete="tel-national"
          placeholder="12 345 6789"
          value={formatLocalPhone(value)}
          onChange={(e) => onChange(e.target.value.replace(/\D/g, '').replace(/^0+/, '').slice(0, 12))}
          aria-invalid={!!error}
          {...rest}
        />
      </div>
      {error ? <p className="field__error">{error}</p> : hint && <p className="field__hint">{hint}</p>}
    </div>
  );
}
